import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';

function EduDriveNavbar() {
    return (
        <Navbar bg="light" expand="lg" fixed="top" className="shadow-sm navbar-hover">
        <Container>
                <Navbar.Brand href="#home" style={{ color: 'var(--primary-color)', fontWeight: 'bold' }}>
                    EduDrive
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link href="#home" className="navbar-link">Inicio</Nav.Link>
                        <Nav.Link href="#features" className="navbar-link">Características</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default EduDriveNavbar;
